import useViewModel from "./viewModel";
import View from "./view";

const Authentication = () => {
  const viewModel = useViewModel();

  return <View {...viewModel} />;
};

export default Authentication;
